import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, CardContent, Button, Grid, Input, Typography, LinearProgress, CardActionArea } from '@mui/material';
import Moment from 'moment';
import { toast } from 'react-toastify';
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';
import { fetchGuest } from '../redux/ActionCreator';
import { useParams } from 'react-router-dom';
const token = localStorage.getItem('token')
const userID = localStorage.getItem('userID')

function ProfileViewPage() {

  const nuser = useSelector((state) => state.guests.guests)
  const { id } = useParams();
  const [acts, setAct] = useState([])
  const dispatch = useDispatch()
  const [formdata, setFormdata] = useState({ creds: '' })
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    dispatch(fetchGuest(token, id));
    async function fetchData() {
      const response = await apiRequest('get', null, `/user/act/${id}`, token, null, {}, true);
      setAct(response.data);
    }
    fetchData();
    // eslint-disable-next-line
  }, [])

  const handleCreds = (e) => {

    setFormdata({
      ...formdata,
      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });

    //console.log(name ,value)
  };

  const CreditExchange = () => {
    setisLoading(true)
    fetch(process.env.REACT_APP_API_URL + '/api/user/credit-xchange', {
      method: 'PUT',
      headers: { "Content-Type": 'application/json' },
      body: JSON.stringify({
        "from_user": userID,
        "to_user": nuser['id'],
        "creds": formdata.creds
      }),

    })
      .then(res => res.json())
      .then(data => {
        //console.log(data)
        if (data.status === 200) {
          toast.success("Credits Sent")
        }
        else {
          toast.error("Credit Balance Insufficient")
        }
        setisLoading(false)
      })
  }

  if (!isLoading) {
    return (
      <Grid container spacing={1} style={{ backgroundColor: '#ffffff', zIndex: 10, borderRadius: 30, marginTop: 100, fontSize: 20, fontFamily: 'Raleway' }}>
        <Grid item md={1}></Grid>
        <Grid item md={7}>

          <Card style={{ borderRadius: 30, zIndex: 10 }}>
            <Grid container spacing={1}>


              <Grid item md={1}></Grid>
              <Grid item xs={12} md={4} style={{ textAlign: 'center' }}><img alt={'profile'} src={nuser['profile_pic']} style={{ height: 200, width: 200, borderRadius: 160 }}></img></Grid>
              <Grid item xs={12} md={3} style={{ fontSize: 40, fontFamily: 'Raleway', textAlign: 'center' }} >

                {nuser['first_name']}&nbsp;
                {nuser['last_name']}
              </Grid>
              <Grid item md={12} xs={1}></Grid>

              <Grid item xs={12}></Grid>
              <Grid item md={1}></Grid>

              <Grid item xs={12}></Grid>
              <Grid item xs={1} md={1}></Grid>


              <Grid container maxWidth='md' style={{ textAlign: 'left' }}>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={6} style={{ fontSize: 30 }}><strong>About</strong></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={10} md={6}>
                  <Typography style={{ fontFamily: 'Raleway' }}> {nuser['about']} </Typography>
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={11}><Input placeholder="Enter Creds to send " name='creds' onChange={handleCreds} /></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={11}><Button style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, fontFamily: 'Raleway', marginTop: 20, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor, borderRadius: 20, textTransform: 'None', width: 160, height: 40 }} onClick={CreditExchange}> Send Cred$</Button></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}></Grid>
                <br></br>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={11}>

                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={1} md={1}></Grid>
                <Grid item xs={11}>

                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid item xs={12}></Grid>
            </Grid>

          </Card>
        </Grid>
        <Grid item md={0.5}></Grid>
        <Grid item md={3}>
          <Typography style={{ textAlign: 'center', fontFamily: 'Raleway', fontSize: 30 }}>{nuser['first_name']}'s programs</Typography>
          <Card>
            <Grid container style={{ height: 400, overflowY: 'auto' }}>
              {acts ? acts.map((info) => {

                return (
                  <Grid container style={{}}>


                    <Grid item xs={12} md={12}>
                      <Card variant='outlined' style={{ borderRadius: 30, marginTop: 20, marginLeft: 20, marginBottom: 20, marginRight: 20, outlineColor: 'black' }} >
                        <CardActionArea >

                          <CardContent style={{ fontFamily: 'Raleway' }}>
                            <Grid container>
                              <Grid item xs={7} md={9} >
                                <Typography component='h1' style={{ fontSize: 20 }}>
                                  {info.title}
                                </Typography>

                              </Grid>

                              <Grid item xs={5} md={3} style={{ borderRadius: 30 }} >
                                <Typography component='h1' style={{ fontSize: 16, fontFamily: 'Raleway', textAlign: 'center', color: 'white', borderRadius: 30 }}>
                                  {info.category}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <br></br>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography component='h5' style={{ color: 'black', fontFamily: 'Raleway' }}>
                                  Service type: {info.service_type === 'O' ? 'Offer' : 'Request'}
                                </Typography>
                              </Grid>

                              <Grid item xs={12}>
                                <Typography component='h5' style={{ color: 'black', fontFamily: 'Raleway' }}>
                                  {info.act_status}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography component='h5' style={{ color: 'black', fontFamily: 'Raleway' }}>
                                  Start Date: {Moment(info.start_date).format('DD MMMM YYYY')}
                                </Typography>
                              </Grid>


                            </Grid>

                          </CardContent>

                        </CardActionArea>

                      </Card>

                    </Grid>

                  </Grid>
                )


              }) : ''}
            </Grid>
          </Card>
        </Grid>
      </Grid>







    )
  }
  else {

    return (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />

      </div>

    )

  }


}



export default ProfileViewPage